<template>
  <div>
    <div class="block">
      <el-carousel :interval='8000' height="550px" @change="change">
        <el-carousel-item>
          <div :style="item" class="item">
            <div class="s1">
              <el-collapse-transition>
                <div v-show="show1" class="box">
                  <img alt="" src="../../assets/photo/silder_01_slogan_01.png">
                </div>
              </el-collapse-transition>
            </div>
            <transition name="el-fade-in-linear">
              <div v-show="show" class="box" style="margin-top:40px;margin-bottom:40px">
                <img alt="" src="../../assets/photo/silder_01_slogan_02.png">
              </div>
            </transition>
            <transition name="el-zoom-in-center">
              <div v-show="show2" class="box">
                <img alt="" src="../../assets/photo/silder_01_slogan_03.png">
              </div>
            </transition>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div :style="item2" class="item">

            <transition name="el-fade-in-linear">
              <div v-show="show3" class="box" style="margin-top:40px;margin-bottom:40px">
                <img alt="" src="../../assets/photo/silder_02_slogan_01.png">
              </div>
            </transition>
            <transition name="el-zoom-in-center">
              <div v-show="show4" class="box">
                <img alt="" src="../../assets/photo/silder_02_slogan_02.png">
              </div>
            </transition>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="container">
      <div class="box">
        <h3>我们的优势</h3>
        <h4>Our advantage</h4>
        <el-row>
          <el-col :span="8">
            <div class="col">
              <div :style="img" class="imgleft"></div>
              <h3>功能丰富, 操作简单</h3>
              <p>全新的交互模式，易学易用的用户体验，真正让用户能够快速高效处理大量数据、深度应用</p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="col cc">
              <div :style="img" class="imgcenter"></div>
              <h3>功能丰富, 操作简单</h3>
              <p>全新的交互模式，易学易用的用户体验，真正让用户能够快速高效处理大量数据、深度应用</p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="col">
              <div :style="img" class="imgright"></div>
              <h3>功能丰富, 操作简单</h3>
              <p>全新的交互模式，易学易用的用户体验，真正让用户能够快速高效处理大量数据、深度应用</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="imgs">
      <img alt="" src="../../assets/photo/main4.png">
      <img alt="" src="../../assets/photo/main5.png">
      <img alt="" src="../../assets/photo/main6.png">
      <img alt="" src="../../assets/photo/main7.png">
    </div>
  </div>
</template>
<script>
export default ({
  name: 'indexHome',
  data() {
    return {
      item: {
        backgroundImage: "url(" + require('../../assets/photo/silder_04.jpg') + ")",
      },
      item2: {
        backgroundImage: "url(" + require('../../assets/photo/silder_02.jpg') + ")",
      },
      img: {
        backgroundImage: "url(" + require('../../assets/photo/superiority.png') + ")",
      },
      show: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
    }
  },
  mounted() {
    this.shows(0)
  },
  methods: {
    login() {
      this.$router.push({name: 'login'})
    },
    register() {
      this.$router.push({name: 'register'})
    },
    shows(val) {
      if (val == 0) {
        this.show1 = false
        this.show = false
        this.show2 = false
        setTimeout(() => {
          this.show1 = true
        }, 1000);
        setTimeout(() => {
          this.show = true
        }, 2000);
        setTimeout(() => {
          this.show2 = true
        }, 3000);
      } else if (val == 1) {
        this.show3 = false
        this.show4 = false
        setTimeout(() => {
          this.show3 = true
        }, 1000);
        setTimeout(() => {
          this.show4 = true
        }, 2000);
      }
    },
    change(a) {
      this.shows(a)
    }
  }
})
</script>

<style lang="less" scoped>
.item {
  width: 100%;
  height: 550px;
  padding-top: 150px;
  background-repeat: no-repeat;
  background-size: cover;

  .s1 {
    height: 55px;
  }

  .box {
    text-align: center;
  }
}

.container {
  height: 500px;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .box {
    padding: 85px;
    width: 1000px;

    h3 {
      text-align: center;
      font-size: 18px;
      color: #5c5c5c;
    }

    h4 {
      text-align: center;
      font-size: 18px;
      color: #5c5c5c;
      padding-bottom: 70px;
    }

    .cc {
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
    }

    .col {
      h3 {
        margin-top: 20px;
        margin-bottom: 10px;
      }

      p {
        width: 180px;
        margin: 0 auto;
      }

      .imgleft {
        height: 63px;
        width: 66px;
        margin: 0 auto;
      }

      .imgcenter {
        height: 63px;
        width: 66px;
        margin: 0 auto;
        background-position: 134px 129px;
      }

      .imgright {
        height: 63px;
        width: 66px;
        margin: 0 auto;
        background-position: 68px 129px;
      }
    }
  }
}

.imgs {
  width: 100%;

  img {
    width: 100%;
  }
}
</style>
